import { api } from '../api/storageApi';

export const saveImageToDB = async (blob: Blob): Promise<string> => {
  const id = crypto.randomUUID();
  await api.images.upload(id, blob);
  return id;
};

export const getImageFromDB = async (id: string): Promise<Blob | null> => {
  try {
    return await api.images.get(id);
  } catch (e) {
    console.error('Failed to get image', e);
    return null;
  }
};

// Deprecated but kept for compatibility if needed, though unused now
export const initDB = async (): Promise<any> => {
  return null;
};
